var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Table",
    {
      staticClass: "overdue-invoice-table",
      staticStyle: { "margin-top": "1rem" }
    },
    [
      _c(
        "TableHeader",
        [
          _c(
            "TableRow",
            _vm._l(_vm.overdueInvoiceSummaryColumns, function(
              overdueInvoiceSummaryCol,
              index
            ) {
              return _c(
                "TableHead",
                { key: `${overdueInvoiceSummaryCol.label}_${index}` },
                [_c("span", [_vm._v(_vm._s(overdueInvoiceSummaryCol.label))])]
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "TableBody",
        _vm._l(_vm.overdueInvoiceSummaryList, function(
          overdueInvoiceSummary,
          index
        ) {
          return _c(
            "TableRow",
            { key: `${overdueInvoiceSummary.name}_${index}` },
            [
              _c(
                "TableCell",
                {
                  staticClass: "name-summary",
                  style: _vm.setInvoiceSummaryStatusColor(
                    overdueInvoiceSummary.name
                  )
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(overdueInvoiceSummary.name) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c("TableCell", { staticClass: "overdue-invoice-table-cell" }, [
                _c(
                  "div",
                  [
                    overdueInvoiceSummary.name.substring(2, 3) === "0" ||
                    ["B", "K", "T"].includes(
                      overdueInvoiceSummary.name.substring(2, 3)
                    )
                      ? _c("RenderMoneyColumnValue", {
                          attrs: {
                            value: !["B", "K", "T"].includes(
                              overdueInvoiceSummary.name.substring(2, 3)
                            )
                              ? _vm.getTotalAmountByStatusPrefix(
                                  overdueInvoiceSummary.name.substring(1, 2),
                                  _vm.overdueInvoiceSummaryList
                                ) || 0
                              : overdueInvoiceSummary.total || 0,
                            "max-fraction-digits": 0
                          }
                        })
                      : _vm._e(),
                    _vm._v("\n          |\n          "),
                    _c("RenderPercentageColumnValue", {
                      attrs: { value: overdueInvoiceSummary.percentageOfTotal }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "TableCell",
                { staticClass: "overdue-invoice-table-cell" },
                [
                  _c("RenderMoneyColumnValue", {
                    attrs: {
                      "max-fraction-digits": 0,
                      value: overdueInvoiceSummary.subtotal
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "TableCell",
                { staticClass: "overdue-invoice-table-cell" },
                [
                  _c("RenderPanoramaSummaryInvoiceLine", {
                    attrs: {
                      "invoice-value": _vm.getSumBoletoVeinsByOverdueInvoiceList(
                        overdueInvoiceSummary.january
                      ),
                      "percentage-invoice-value": _vm.getSumPercentageByOverdueInvoiceList(
                        overdueInvoiceSummary.january
                      ),
                      status: overdueInvoiceSummary.name
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "TableCell",
                { staticClass: "overdue-invoice-table-cell" },
                [
                  _c("RenderPanoramaSummaryInvoiceLine", {
                    attrs: {
                      "invoice-value": _vm.getSumBoletoVeinsByOverdueInvoiceList(
                        overdueInvoiceSummary.february
                      ),
                      "percentage-invoice-value": _vm.getSumPercentageByOverdueInvoiceList(
                        overdueInvoiceSummary.february
                      ),
                      status: overdueInvoiceSummary.name
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "TableCell",
                { staticClass: "overdue-invoice-table-cell" },
                [
                  _c("RenderPanoramaSummaryInvoiceLine", {
                    attrs: {
                      "invoice-value": _vm.getSumBoletoVeinsByOverdueInvoiceList(
                        overdueInvoiceSummary.march
                      ),
                      "percentage-invoice-value": _vm.getSumPercentageByOverdueInvoiceList(
                        overdueInvoiceSummary.march
                      ),
                      status: overdueInvoiceSummary.name
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "TableCell",
                { staticClass: "overdue-invoice-table-cell" },
                [
                  _c("RenderPanoramaSummaryInvoiceLine", {
                    attrs: {
                      "invoice-value": _vm.getSumBoletoVeinsByOverdueInvoiceList(
                        overdueInvoiceSummary.april
                      ),
                      "percentage-invoice-value": _vm.getSumPercentageByOverdueInvoiceList(
                        overdueInvoiceSummary.april
                      ),
                      status: overdueInvoiceSummary.name
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "TableCell",
                { staticClass: "overdue-invoice-table-cell" },
                [
                  _c("RenderPanoramaSummaryInvoiceLine", {
                    attrs: {
                      "invoice-value": _vm.getSumBoletoVeinsByOverdueInvoiceList(
                        overdueInvoiceSummary.may
                      ),
                      "percentage-invoice-value": _vm.getSumPercentageByOverdueInvoiceList(
                        overdueInvoiceSummary.may
                      ),
                      status: overdueInvoiceSummary.name
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "TableCell",
                { staticClass: "overdue-invoice-table-cell" },
                [
                  _c("RenderPanoramaSummaryInvoiceLine", {
                    attrs: {
                      "invoice-value": _vm.getSumBoletoVeinsByOverdueInvoiceList(
                        overdueInvoiceSummary.june
                      ),
                      "percentage-invoice-value": _vm.getSumPercentageByOverdueInvoiceList(
                        overdueInvoiceSummary.june
                      ),
                      status: overdueInvoiceSummary.name
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "TableCell",
                { staticClass: "overdue-invoice-table-cell" },
                [
                  _c("RenderPanoramaSummaryInvoiceLine", {
                    attrs: {
                      "invoice-value": _vm.getSumBoletoVeinsByOverdueInvoiceList(
                        overdueInvoiceSummary.july
                      ),
                      "percentage-invoice-value": _vm.getSumPercentageByOverdueInvoiceList(
                        overdueInvoiceSummary.july
                      ),
                      status: overdueInvoiceSummary.name
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "TableCell",
                { staticClass: "overdue-invoice-table-cell" },
                [
                  _c("RenderPanoramaSummaryInvoiceLine", {
                    attrs: {
                      "invoice-value": _vm.getSumBoletoVeinsByOverdueInvoiceList(
                        overdueInvoiceSummary.august
                      ),
                      "percentage-invoice-value": _vm.getSumPercentageByOverdueInvoiceList(
                        overdueInvoiceSummary.august
                      ),
                      status: overdueInvoiceSummary.name
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "TableCell",
                { staticClass: "overdue-invoice-table-cell" },
                [
                  _c("RenderPanoramaSummaryInvoiceLine", {
                    attrs: {
                      "invoice-value": _vm.getSumBoletoVeinsByOverdueInvoiceList(
                        overdueInvoiceSummary.september
                      ),
                      "percentage-invoice-value": _vm.getSumPercentageByOverdueInvoiceList(
                        overdueInvoiceSummary.september
                      ),
                      status: overdueInvoiceSummary.name
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "TableCell",
                { staticClass: "overdue-invoice-table-cell" },
                [
                  _c("RenderPanoramaSummaryInvoiceLine", {
                    attrs: {
                      "invoice-value": _vm.getSumBoletoVeinsByOverdueInvoiceList(
                        overdueInvoiceSummary.october
                      ),
                      "percentage-invoice-value": _vm.getSumPercentageByOverdueInvoiceList(
                        overdueInvoiceSummary.october
                      ),
                      status: overdueInvoiceSummary.name
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "TableCell",
                { staticClass: "overdue-invoice-table-cell" },
                [
                  _c("RenderPanoramaSummaryInvoiceLine", {
                    attrs: {
                      "invoice-value": _vm.getSumBoletoVeinsByOverdueInvoiceList(
                        overdueInvoiceSummary.november
                      ),
                      "percentage-invoice-value": _vm.getSumPercentageByOverdueInvoiceList(
                        overdueInvoiceSummary.november
                      ),
                      status: overdueInvoiceSummary.name
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "TableCell",
                { staticClass: "overdue-invoice-table-cell" },
                [
                  _c("RenderPanoramaSummaryInvoiceLine", {
                    attrs: {
                      "invoice-value": _vm.getSumBoletoVeinsByOverdueInvoiceList(
                        overdueInvoiceSummary.december
                      ),
                      "percentage-invoice-value": _vm.getSumPercentageByOverdueInvoiceList(
                        overdueInvoiceSummary.december
                      ),
                      status: overdueInvoiceSummary.name
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }